export default __webpack_public_path__ + "static/media/account.bbcf868e.png";